module.exports = __webpack_public_path__ + "static/img/BT.4c7abd90.svg";